import { UserProfileStatus, WorkOrderStatusType } from "./enum";

export const brandName = "Tech Domain";
export const brandFontFamily = "Poppins";
export const brandInputTextColor = "#686868";
export const brandSecondaryColor = "#FF5F00";
export const brandPrimaryColor = "#0F40AE";
export const tableFontSize = "13px";
export const INCOMPLETE_CHIP_COLOR = "#800080";
export const brandFontSize = "13px"; //should always match with p tag
export const ROLES = {
  FREELANCE: "FREELANCER",
  CLIENT: "CLIENT",
  ADMIN: "ADMIN",
};
export const workOrderStatus = [
  WorkOrderStatusType.DRAFT,
  WorkOrderStatusType.PUBLISHED,
  WorkOrderStatusType.ROUTED,
  WorkOrderStatusType.ASSIGNED,
  WorkOrderStatusType.CANCELLED,
  WorkOrderStatusType.INPROGRESS,
  WorkOrderStatusType.WORKDONE,
  WorkOrderStatusType.INCOMPLETE,
  WorkOrderStatusType.VERIFIED,
  WorkOrderStatusType.CANCELLED_PAYABLE,
  WorkOrderStatusType.APPROVED,
  WorkOrderStatusType.INVOICED,
  WorkOrderStatusType.PAID,
];

export const workOrderStatusOptions = [
  { label: "Draft", value: WorkOrderStatusType.DRAFT },
  { label: "Published", value: WorkOrderStatusType.PUBLISHED },
  { label: "Routed", value: WorkOrderStatusType.ROUTED },
  { label: "Assigned", value: WorkOrderStatusType.ASSIGNED },
  { label: "In Progress", value: WorkOrderStatusType.INPROGRESS },
  { label: "Incomplete", value: WorkOrderStatusType.INCOMPLETE },
  { label: "Cancelled", value: WorkOrderStatusType.CANCELLED },
  { label: "Work Done", value: WorkOrderStatusType.WORKDONE },
  { label: "Verified", value: WorkOrderStatusType.VERIFIED },
  { label: "Approved", value: WorkOrderStatusType.APPROVED },
  { label: "Invoiced", value: WorkOrderStatusType.INVOICED },
  { label: "Paid", value: WorkOrderStatusType.PAID },
];

export const profileStatusOptions = [
  { label: "Pending", value: UserProfileStatus.PENDING },
  { label: "Submitted", value: UserProfileStatus.SUBMITTED },
  { label: "Active", value: UserProfileStatus.APPROVED },
  { label: "In-Active", value: UserProfileStatus.DEACTIVATED },
  { label: "Incomplete", value: UserProfileStatus.UNAPPROVE },
];

export const companyTypeOptions = [
  { label: "Freelance Company", value: "FREELANCE" },
  { label: "Client Company", value: "CLIENT" },
];

export const serviceDesk = {
  name: "Operations Service Desk",
  description: "Technical help & Coordination",
  phone: "+61 2 91583294",
  email: "operations@techdomain.com.au",
  note: "Please contact our service desk if you have any query regarding site access or problem in job completion.",
};

export const languageOptions = [
  { label: "Afrikaans", value: "AFRIKAANS" },
  { label: "Haitian Creole", value: "HAITIAN_CREOLE" },
  { label: "Norwegian", value: "NORWEGIAN" },
  { label: "Albanian", value: "ALBANIAN" },
  { label: "Hakha Chin", value: "HAKHA_CHIN" },
  { label: "Oromo", value: "OROMO" },
  { label: "Amharic", value: "AMHARIC" },
  { label: "Hakka (Chinese)", value: "HAKKA_CHINESE" },
  { label: "Pashto", value: "PASHTO" },
  { label: "Arabic", value: "ARABIC" },
  { label: "Hebrew", value: "HEBREW" },
  { label: "Polish", value: "POLISH" },
  { label: "Armenian (Eastern)", value: "ARMENIAN_EASTERN" },
  { label: "Hindi", value: "HINDI" },
  { label: "Portuguese (Brazil)", value: "PORTUGUESE_BRAZIL" },
  { label: "Armenian (Western)", value: "ARMENIAN_WESTERN" },
  { label: "Hmong", value: "HMONG" },
  { label: "Portuguese (Portugal)", value: "PORTUGUESE_PORTUGAL" },
  { label: "Azerbaijani (Azeri)", value: "AZERBAIJANI_AZERI" },
  { label: "Hungarian", value: "HUNGARIAN" },
  { label: "Punjabi", value: "PUNJABI" },
  { label: "Bassa", value: "BASSA" },
  { label: "Icelandic", value: "ICELANDIC" },
  { label: "Rohingya", value: "ROHINGYA" },
  { label: "Belarusian", value: "BELARUSIAN" },
  { label: "Igbo/Ibo", value: "IGBO_IBO" },
  { label: "Romanian (Moldavan)", value: "ROMANIAN_MOLDAVAN" },
  { label: "Bengali", value: "BENGALI" },
  { label: "Ilocano", value: "ILOCCANO" },
  { label: "Russian", value: "RUSSIAN" },
  { label: "Bosnian", value: "BOSNIAN" },
  { label: "Ilonggo (Hiligaynon)", value: "ILONGGO_HILIGAYNON" },
  { label: "Serbian", value: "SERBIAN" },
  { label: "Braille", value: "BRAILLE" },
  { label: "Indonesian", value: "INDONESIAN" },
  { label: "Slovak", value: "SLOVAK" },
  { label: "Bulgarian", value: "BULGARIAN" },
  { label: "Italian", value: "ITALIAN" },
  { label: "Slovenian", value: "SLOVENIAN" },
  { label: "Burmese", value: "BURMESE" },
  { label: "Japanese", value: "JAPANESE" },
  { label: "Somali", value: "SOMALI" },
  { label: "Cambodian (Khmer)", value: "CAMBODIAN_KHMER" },
  { label: "Javanese", value: "JAVANESE" },
  { label: "Spanish (Castilian)", value: "SPANISH_CASTILIAN" },
  { label: "Cape Verde Creole", value: "CAPE_VERDE_CREOLE" },
  { label: "Kannada", value: "KANNADA" },
  { label: "Spanish (Latin American)", value: "SPANISH_LATIN_AMERICAN" },
  { label: "Cebuano", value: "CEBUANO" },
  { label: "Karen", value: "KAREN" },
  { label: "Spanish (other varieties)", value: "SPANISH_OTHER_VARIETIES" },
  { label: "Chinese (Simplified)", value: "CHINESE_SIMPLIFIED" },
  { label: "Kazakh", value: "KAZAKH" },
  { label: "Swahili", value: "SWAHILI" },
  { label: "Chinese (Traditional)", value: "CHINESE_TRADITIONAL" },
  { label: "Kinyarwanda", value: "KINYARWANDA" },
  { label: "Swedish", value: "SWEDISH" },
  { label: "Chuukese", value: "CHUKESE" },
  { label: "Kirundi", value: "KIRUNDI" },
  { label: "Tagalog", value: "TAGALOG" },
  { label: "Croatian", value: "CROATIAN" },
  { label: "Korean", value: "KOREAN" },
  { label: "Tamil", value: "TAMIL" },
  { label: "Czech", value: "CZECH" },
  { label: "Kurdish (Kurmanji dialect)", value: "KURDISH_KURMANJI" },
  { label: "Telugu", value: "TELUGU" },
  { label: "Danish", value: "DANISH" },
  { label: "Kurdish (Sorani dialect)", value: "KURDISH_SORANI" },
  { label: "Thai", value: "THAI" },
  { label: "Dari", value: "DARI" },
  { label: "Kyrgyz/Kirgiz", value: "KYRGYZ_KIRGIZ" },
  { label: "Tibetan", value: "TIBETAN" },
  { label: "Dutch", value: "DUTCH" },
  { label: "Lao (Laotian)", value: "LAO_LAOTIAN" },
  { label: "Tigrinya", value: "TIGRINYA" },
  { label: "English", value: "ENGLISH" },
  { label: "Latvian", value: "LATVIAN" },
  { label: "Turkish", value: "TURKISH" },
  { label: "Estonian", value: "ESTONIAN" },
  { label: "Lithuanian", value: "LITHUANIAN" },
  { label: "Ukrainian", value: "UKRAINIAN" },
  { label: "Farsi (Persian)", value: "FARSI_PERSIAN" },
  { label: "Macedonian", value: "MACEDONIAN" },
  { label: "Urdu", value: "URDU" },
  { label: "Finnish", value: "FINNISH" },
  { label: "Malay (Malaysian)", value: "MALAY_MALAYSIAN" },
  { label: "Uzbek", value: "UZBEK" },
  { label: "Flemmish", value: "FLEMMISH" },
  { label: "Mandinka", value: "MANDINKA" },
  { label: "Vietnamese", value: "VIETNAMESE" },
  { label: "French (Canada)", value: "FRENCH_CANADA" },
  { label: "Marathi", value: "MARATHI" },
  { label: "Wolof", value: "WOLOF" },
  { label: "French (France)", value: "FRENCH_FRANCE" },
  { label: "Marshallese", value: "MARSHALLESE" },
  { label: "Yoruba", value: "YORUBA" },
  { label: "Fulani", value: "FULANI" },
  { label: "Mien", value: "MIEN" },
  { label: "Georgian", value: "GEORGIAN" },
  { label: "Mongolian", value: "MONGOLIAN" },
  { label: "German", value: "GERMAN" },
  { label: "Montenegrin", value: "MONTENEGRIN" },
  { label: "Greek", value: "GREEK" },
  { label: "Navajo", value: "NAVAJO" },
  { label: "Gujarati", value: "GUJARATI" },
  { label: "Nepali", value: "NEPALI" },
];
